<template>
  <div
    class="nested-container"
    :class="{ 'nested-container--is-scrolled': isScrolled }"
  >
    <component
      :is="scrollContainer"
      ref="scrollContainer"
      class="nested-container__wrapper"
      :class="{
        'nested-container__wrapper--limited': answersExpanded
      }"
      v-on="containerEvents"
    >
      <slot />
    </component>

    <ToggleButton
      v-if="showToggleButton"
      :icon="toggleButtonIcon"
      :label="toggleButtonLabel"
      @toggle="toggleAnswers"
    />
  </div>
</template>

<script>
import ToggleButton from "@/components/QuestionsAndAnswers/QaListToggleButton.vue";

export default {
  name: "QaListItemNestedContainer",
  components: {
    ToggleButton
  },
  props: {
    itemsQuantity: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      answersExpanded: false,
      isScrolled: false
    };
  },
  computed: {
    showToggleButton() {
      return this.itemsQuantity > 2;
    },
    scrollContainer() {
      return this.answersExpanded ? "vue-perfect-scrollbar" : "div";
    },
    containerEvents() {
      if (!this.answersExpanded) return {};
      return {
        "ps-scroll-y": this.handleScrollStart
      };
    },
    toggleButtonLabel() {
      return this.answersExpanded
        ? this.$t("message.questionsAndAnswers.collapseAnswers")
        : this.$t("message.questionsAndAnswers.expandAnswers", [
            this.itemsQuantity - 2
          ]);
    },
    toggleButtonIcon() {
      return this.answersExpanded ? "mdi-chevron-up" : "mdi-dots-vertical";
    }
  },
  methods: {
    handleScrollStart(e) {
      this.isScrolled = e.target.scrollTop > 0;
    },
    async toggleAnswers() {
      this.answersExpanded = !this.answersExpanded;
      this.isScrolled = false;

      this.$emit("toggle-answers", this.answersExpanded);
    }
  },
  watch: {
    itemsQuantity(current, previous) {
      if (current > 2 && !this.answersExpanded) {
        this.toggleAnswers();
      }
      this.$nextTick(() => {
        const ps = this.$refs.scrollContainer.ps;
        const contentHeight = ps.element.scrollHeight;
        ps.element.scrollTop = current > previous ? contentHeight : 0;
        ps.update();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .ps-container > .ps__rail-x,
  .ps-container > .ps__rail-y {
    opacity: 0.6 !important;
  }
}

.nested-container {
  display: flex;
  flex-direction: column;
  gap: $spacing * 2;
  margin-top: $spacing * 2;

  &--is-scrolled {
    position: relative;

    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 10px;
      box-shadow: inset 0 10px 10px -10px rgba(0, 0, 0, 0.15);
      z-index: 1;
      border-radius: 0 0 16px 16px;
    }
  }

  &__wrapper {
    padding-bottom: $spacing * 0.2;
    display: flex;
    flex-direction: column;
    gap: $spacing * 2;

    &--limited {
      max-height: 600px;
    }
  }
}
</style>
